var FactoryVRProperty=0;
function VRProperty()
{
    FactoryVRProperty++;
    this.init.apply(this,Array.prototype.slice.call(arguments,0));
    return this;
}


$.extend(VRProperty.prototype,{
    el:null,
    $el:null,
    template:'<div class="multiimages-drop-zone"> <label > <span><i class="zmdi zmdi-upload"></i> '+window.LANGUAGE['multi.upload-drop-files']+'</span> <ul class="images"></ul></label> <input type="file" multiple> </div>',
    content:null,
    input:null,
    images:null,
    fieldName:'images',
    updateCB:null,
    init:function(element,fieldName) {
        this.el=element;
        this.$el=$(this.el);
        this.fieldName=fieldName;

        this.content=$(this.template);
        this.images=this.content.find("ul.images");
        this.$el.append(this.content);
        this.input=this.content.find("input");
        this.input.attr("id","vrproperty_"+FactoryVRProperty);
        this.content.find("label").attr("for","vrproperty_"+FactoryVRProperty);

        this.attachDropEvents();
        this.input[0].style.display='none';
        this.grabImages();
    },
    grabImages:function()
    {
        var imgs=this.$el.find("img");
        for(var i=0;i<imgs.length;i++)
        {
            var img=$(imgs[i]);
            var rImg=new Image();
            rImg.src=img.attr("src");
            this.createCropper(rImg,img.attr("data-id"),img.attr("data-name"));
            img.remove();

        }
    },
    attachDropEvents:function() {
        this.content[0].addEventListener('dragover', this.handleDragOver.bind(this));
        this.content[0].addEventListener('dragleave', this.handleDragLeave.bind(this));
        this.content[0].addEventListener('drop', this.handleDrop.bind(this));
        this.input[0].addEventListener('change', this.handleFileSelect.bind(this));
    },
    handleDragOver: function (e) {
        e.preventDefault();
        if(!this.$el.hasClass("hover-drag"))
            this.$el.addClass("hover-drag");
    },
    handleDragLeave: function (e) {
        e.preventDefault();
        this.$el.removeClass("hover-drag");
    },
    handleDrop:function (e) {
        e.preventDefault();
        this.$el.removeClass("hover-drag");
        this.handleFileItems(e.dataTransfer.items || e.dataTransfer.files);
    },
    handleFileSelect:function(e) {
        this.handleFileItems(e.target.files);
    },
    handleFileItems:function(items) {
        var l = items.length;
        for (var i=0; i<l; i++) {
          this.handleItem(items[i]);
        }
    },
    handleItem:function(item) {

        // get file from item
        var file = item;
        if (item.getAsFile && item.kind =='file') {
            file = item.getAsFile();
        }

        this.handleFile(file);
    },
    handleFile: function(file) {
        this.createCropper(file);
    },
    createCropper: function(file, media_id,namevel) {
        // create container element for cropper
        var cropper = $('<li><div class="image"><div class="slim-wrap"></div></div><div class="field"><label>'+window.LANGUAGE['vr.fieldname']+'</label><div class="fg-line"><input class="form-control" name="'+this.fieldName+'[name][]" data-grab="vrprop" value="'+(namevel?namevel:'')+'"/></div></div></li>');
        if(media_id) {
            cropper.attr("data-id", media_id);
            cropper.find(".slim-wrap").append(file);
        }
        cropper.find(".slim-wrap").append('<input type="file" name="'+this.fieldName+'[file][]" data-grab="vrprop"/>');
        this.images.append(cropper);
        var self=this;
        Slim.create(cropper.find(".slim-wrap")[0], {
            meta:{
                media_id:media_id
            },
            download:true,
            "label":LANGUAGE["slim.label"],
            "buttonCancelTitle":LANGUAGE["basic.cancel"],
            "buttonEditTitle":LANGUAGE["slim.button-edit-title"],
            "buttonRemoveTitle":LANGUAGE["slim.button-remove-title"],
            "buttonDownloadTitle":LANGUAGE["slim.button-download-title"],
            "buttonUploadTitle":LANGUAGE["slim.button-upload-title"],
            "buttonConfirmTitle":LANGUAGE["basic.apply"],
            "buttonCancelLabel":LANGUAGE["basic.cancel"],
            "buttonEditLabel":LANGUAGE["slim.button-edit-label"],
            "buttonRemoveLabel":LANGUAGE["slim.button-remove-label"],
            "buttonDownloadLabel":LANGUAGE["slim.button-download-label"],
            "buttonUploadLabel":LANGUAGE["slim.button-upload-label"],
            "buttonConfirmLabel":LANGUAGE["basic.apply"],
         /*   defaultInputName: this.fieldName+'[]',*/
            didInit: function() {
                // load the file to our slim cropper
                if(!media_id)
                    this.load(file);
                if(self.images.find("li").length>0 && !self.images.hasClass("active"))
                    self.images.addClass("active")

                self.input.closest('form').attr('data-dirty',true);
            },
            didRemove: function() {
                cropper.remove();
                this.destroy();
                if(self.images.find("li").length==0 && self.images.hasClass("active"))
                    self.images.removeClass("active");

                $("input[name='"+self.fieldName+"[file][]'][value='"+media_id+"']").remove();

                self.images.append($("<input  data-grab=\"vrprop\"/>").attr("type","hidden").attr("name",self.fieldName+"[deletes][]").attr("value",JSON.stringify({
                    action:'delete',
                    media_id:media_id
                })));

                self.input.closest('form').attr('data-dirty',true);
            }
        });

        cropper.find("input[type=hidden]").val(media_id);
    }
});

$(function(){
    $(".vrproperty").each(function(i,item){
        if(item.vrp)
            return;
            item.vrp = new VRProperty(item);

    });
});